import React from "react";  
import OrdensNotScriptedListPageContainer from "./OrdensNotScriptedListPageContainer";

export class OrdensNotScriptedListPage extends React.Component {
  render() {
    return <OrdensNotScriptedListPageContainer {...this.props} />;
  }
}
